import axios from 'axios';
import { AppConfig, JWT } from '../config';
import { ErrorCodeConstant } from './constants/ErrorCodeConstant';
import { AlertAction } from './AlertAction';
import { Translate as t } from '../config/Translate';

const GetList = () => async (dispatch) => {
	dispatch({ type: ErrorCodeConstant.LOADING });
	try {
		const aggregate = [];
		aggregate.push({ '$match': { isDel: false } });
		aggregate.push({
			'$project': {
				'errorCode' : 1,
				'lang' : 1,
				'model' : 1,
				'occurs' : 1,
				'like' : 1,
				'technote' : 1,
			}
		});
		const data = {
			data : {
				type: "errorcode",
				aggregate,
				passfilter: true,
			}
		}
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/q', data, JWT());
		if (ret?.data?.status == 'success') {
			dispatch({ type: ErrorCodeConstant.ERRORCODE_GET_LIST, errorCodes: ret.data.data });
		} else {
			dispatch(AlertAction.Error(ret?.data));
		}
	} catch (error) {
		console.warn('[ErrorCodeAction.GetList] failed', {
			handler: 'ErrorCodeAction.GetList',
			reason: error?.message || String(error),
		});
	} finally {
		dispatch({ type: ErrorCodeConstant.LOADED });
	}
};

const GetOne = (errorCode, lang) => async (dispatch) => {
	dispatch({ type: ErrorCodeConstant.LOADING });
	try {
		const ret = await axios.get(AppConfig.API_SERVER_PATH + '/errorcode/' + errorCode + '/' + lang, JWT());
		if (ret?.data?.status == 'success') {
			if (ret.data) {
				dispatch({ type: ErrorCodeConstant.ERRORCODE_GET_ONE, errorCode: ret.data.data });
			} else {
				dispatch(AlertAction.Error(ret.data));
			}
		} else {
			dispatch(AlertAction.Error(ret?.data));
		}
	} catch (error) {
		console.warn('[ErrorCodeAction.GetOne] failed', {
			handler: 'ErrorCodeAction.GetOne',
			reason: error?.message || String(error),
		});
	} finally {
		dispatch({ type: ErrorCodeConstant.LOADED });
	}
};

const GetOneById = (_id) => async (dispatch) => {
	dispatch({ type: ErrorCodeConstant.LOADING });

	try {
		const ret = await axios.get(AppConfig.API_SERVER_PATH + '/errorcode/' + _id, JWT());

		if (ret?.data?.status == 'success') {
			if (ret.data) {
				dispatch({ type: ErrorCodeConstant.ERRORCODE_GET_ONE, errorCode: ret.data.data });
			} else {
				dispatch(AlertAction.Error(ret.data));
			}
		} else {
			dispatch(AlertAction.Error(ret?.data));
		}
	} catch (error) {
		console.warn('[ErrorCodeAction.GetOneById] failed', {
			handler: 'ErrorCodeAction.GetOneById',
			reason: error?.message || String(error),
		});
	} finally {
		dispatch({ type: ErrorCodeConstant.LOADED });
	}
};

const GetOneOnlyErrorCode = async (model, errorCode) => {
	try {
		const ret = await axios.post(
			AppConfig.API_SERVER_PATH + '/errorcode/' + errorCode,
			{ type: 'getbyonlyerrorcode', model: model },
			JWT()
		);
		if (ret.data.status == 'success') {
			return ret.data.data;
		} else {
			AlertAction.Error(ret.data);
			return [];
		}
	} catch (error) {
		console.error('GetOneOnlyErrorCode error:', error);
		return [];
	}
};

const Add = (errorCode) => async (dispatch) => {
	dispatch({ type: ErrorCodeConstant.LOADING });
	try {
		const data = {
			who: JSON.parse(localStorage.getItem('user')).adminid,
			type: 'create',
			data: errorCode,
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/errorcode', data, JWT());
		if (ret?.data?.status == 'success') {
			dispatch(AlertAction.Success(t('common.message.success.saved')));
			dispatch({ type: ErrorCodeConstant.ERRORCODE_ADD, errorCode: ret.data.data });
		} else {
			dispatch(AlertAction.Error(ret?.data));
		}
	} catch (error) {
		console.warn('[ErrorCodeAction.Add] failed', {
			handler: 'ErrorCodeAction.Add',
			reason: error?.message || String(error),
		});
		dispatch(AlertAction.Error(error));
	} finally {
		dispatch({ type: ErrorCodeConstant.LOADED });
	}
};

const Update = (errorCode, lang, errorCodeInfo, type = "update") => async (dispatch) => {
	dispatch({ type: ErrorCodeConstant.LOADING });
	try {
		const data = {
			who: JSON.parse(localStorage.getItem('user')).adminid,
			type: type,
			data: errorCodeInfo,
		};

		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/errorcode/' + errorCode + '/' + lang, data, JWT());

		if (ret?.data?.status == 'success') {
			dispatch(AlertAction.Success(t(/^(del|remove)/i.test(String(type)) ? 'common.message.deleted' : 'common.message.success.saved')));
			dispatch({ type: ErrorCodeConstant.ERRORCODE_UPDATE, errorCode: ret.data.data });
		} else {
			dispatch(AlertAction.Error(ret?.data));
		}
	} catch (error) {
		console.warn('[ErrorCodeAction.Update] failed', {
			handler: 'ErrorCodeAction.Update',
			reason: error?.message || String(error),
		});
		dispatch(AlertAction.Error(error));
	} finally {
		dispatch({ type: ErrorCodeConstant.LOADED });
	}
};


const Delete = (errorCode, lang) => async (dispatch) => {
	dispatch({ type: ErrorCodeConstant.LOADING });
	try {
		const data = {
			who: JSON.parse(localStorage.getItem('user')).adminid,
			type: 'delete',
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/errorcode/' + errorCode + '/' + lang, data, JWT());
		if (ret?.data?.status == 'success') {
			dispatch(AlertAction.Success(t('common.message.deleted')));
			dispatch({ type: ErrorCodeConstant.ERRORCODE_DELETE, delitem: { errorCode: errorCode, lang: lang } });
		} else {
			dispatch(AlertAction.Error(ret?.data));
		}
	} catch (error) {
		console.warn('[ErrorCodeAction.Delete] failed', {
			handler: 'ErrorCodeAction.Delete',
			reason: error?.message || String(error),
		});
		dispatch(AlertAction.Error(error));
	} finally {
		dispatch({ type: ErrorCodeConstant.LOADED });
	}
};

const GetComboList = async () => {
	try {
		const ret = await axios.get(AppConfig.API_SERVER_PATH + '/errorcode/getcombo', JWT());
		if (ret.data.status == 'success') {
			return ret.data.data;
		} else {
			console.warn('[ErrorCodeAction.GetComboList] non-success', {
				handler: 'ErrorCodeAction.GetComboList',
				reason: 'status != success',
			});
			return [];
		}
	} catch (error) {
		console.warn('[ErrorCodeAction.GetComboList] failed', {
			handler: 'ErrorCodeAction.GetComboList',
			reason: error?.message || String(error),
		});
		return [];
	}
};

const ClearUpdateResult = () => (dispatch) => {
	dispatch(success());
	function success() {
		return { type: ErrorCodeConstant.ERRORCODE_CLEAR_UPDATERES };
	}
};

export const ErrorCodeAction = {
	GetList,
	GetOne,
	GetOneById,
	GetOneOnlyErrorCode,
	Add,
	Update,
	Delete,
	ClearUpdateResult,
	GetComboList,
};
